import React, { useEffect, useState } from "react";
import Add from "../../assets/images/add.svg";
import Sub from "../../assets/images/remove.svg";
import Ac from "../../assets/images/ac.svg";
import { ReactSVG } from "react-svg";
import { withTranslation } from "react-i18next";

import { connect } from "react-redux";
import moment from "moment";
import { withRouter } from "react-router-dom";
import { mapDispatchToProps, mapStateToProps } from "../../actions/addresses";
import PendingTransaction from "./pendingTransaction";
import Loader from "../Loader/Loader";
import PendingTransactionOverview from "./PendingTransactionOverview";
import * as sdk from "boa-sdk-ts";
import { WalletMA } from "boa-sdk-ts";
import {
  getWalletData,
  isLockPeriod,
  loadContactList,
} from "../../utils/WalletUtils";
import { ErrorCheckUtil } from "../../utils/ErrorCheckUtil";
import Address from "../common/address";
import { AmountBOA } from "../common/amountBOA";

const OverView = (props) => {
  // this is total states of the current component
  const { t, selectedAccount, getSocketConnection, endpoint } = props;

  const [address, setAddresses] = useState([]);
  const [txHash, setTxHash] = useState("");
  const [tx, setTx] = useState();
  const [showCancellationTransaction, setShowCancellationTransaction] =
    useState(false);
  const [transcationTypeInfo, setTranscationType] = useState({
    inbound: false,
    outbound: false,
  });
  const [utxo, setUtxo] = useState({ peer: false, block: false });
  const [date, SetDate] = useState({ From: undefined, To: undefined });
  const [WalletNames, setWalletNames] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [ShowOverDetailInfo, SetShowOverDetails] = useState(false);
  const [showPendingTransaction, setShowPendingTransaction] = useState(false);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState("");
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    setWalletNames(getWalletData());
    setContactList(loadContactList());
    return () => {
      setShowPendingTransaction(false);
      setLoader(false);
      setMounted(false);
    };
  }, []);

  // Hook to call transactionHistory method and pass selected account public address
  useEffect(() => {
    if (selectedAccount && selectedAccount.address.toString()) {
      getTaranscationHistory(selectedAccount.address.toString());
    }
  }, [
    selectedAccount,
    transcationTypeInfo,
    date,
    getSocketConnection,
    endpoint,
  ]);

  // Method to get Transaction History
  const getTaranscationHistory = async (SelectedAddress) => {
    const { client } = WalletMA.instance();

    const public_key = new sdk.PublicKey(SelectedAddress);
    const res = await client.getTransactionHistory(public_key, 10, 1, [
      "inbound",
      "outbound",
      "payload",
      "freeze",
    ]);
    if (mounted) {
      setLoader(false);
      if (ErrorCheckUtil.resCodeCheck(res)) {
        if (res.data !== undefined) {
          setAddresses(res.data.items);
        } else {
          setError(t("sorry_no_data"));
        }
      }
    }
  };

  // Method use show Details of transcation and get select record of transcation
  const showOverDetails = (record) => {
    props.history.push({
      pathname: "overview/transactionDetail",
      state: { tx_hash: record.tx_hash },
    });
  };

  const showPendingTransactionOverview = (tx_hash) => {
    setTxHash(tx_hash);
    setShowPendingTransaction(true);
    SetShowOverDetails(true);
  };

  const showCancellationTransactionOverview = (tx) => {
    setTx(tx);
    setShowCancellationTransaction(true);
    setShowPendingTransaction(false);
    SetShowOverDetails(true);
  };

  // Get WalletName from account according to address pass in param
  const getWalletNameFromHistory = (address) => {
    let walletName = WalletNames.filter((info) => info.address === address);
    return walletName && walletName[0] && walletName[0].name;
  };

  // Get Peer name from contact list according to address pass in param
  const getPeerNameFromContactList = (address) => {
    let peerName = contactList.filter(
      (info) => info.contactWalletAddress === address
    );
    return peerName && peerName[0] && peerName[0].contactAddressName
      ? peerName[0].contactAddressName.length > 24
        ? peerName[0].contactAddressName.slice(0, 12) +
          `…` +
          peerName[0].contactAddressName.slice(-1 * 12)
        : peerName[0].contactAddressName
      : address.slice(0, 12) + `…` + address.slice(-1 * 12);
  };

  const TimeZoneFormat = (time) => {
    if (props.getTimeZone && props.getTimeZone.TimeZone === "Local Time") {
      return moment(time * 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment.utc(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  };

  const DateFormat = (time) => {
    if (props.getTimeZone && props.getTimeZone.TimeZone === "Local Time") {
      return moment(time * 1000)
        .local()
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return moment.utc(time * 1000).format("YYYY-MM-DD HH:mm:ss");
    }
  };

  return (
    <>
      <div className="Content">
        <div className="TableBg cardBg">
          <div className="ContHeader">
            <h3>{t("Recent_Transactions")}</h3>
          </div>
          {/* Recent Transactions history section  */}
          <div className="table-responsive recent-table recent-table-h1">
            <table className="table panelTable">
              <thead className="tableHead">
                <tr>
                  <th>{t("Transaction_type")}</th>
                  {utxo.block && <th>{t("Block_height")}</th>}
                  <th>{t("Time")}</th>
                  <th className="amount_align">{t("Amount")}</th>
                  <th>{t("Peer")}</th>
                  {utxo.peer && <th>{t("Account")}</th>}
                  <th>{t("Lock_period")}</th>
                </tr>
              </thead>
              {address.length > 0 ? (
                <tbody className="tablebody">
                  {address.map((info, index) => (
                    <tr
                      className={
                        info.unlock_time > info.time
                          ? "cursor"
                          : "cursor unlockTimeBg"
                      }
                      onClick={() => showOverDetails(info)}
                      key={index}
                    >
                      <td>
                        <span
                          className={
                            info.display_tx_type === "freeze"
                              ? "TreeIcon"
                              : info.display_tx_type === "inbound"
                              ? "plusIcon"
                              : "SubIcon"
                          }
                        >
                          <ReactSVG
                            className="img-fluid"
                            src={
                              info.display_tx_type === "freeze"
                                ? Ac
                                : info.display_tx_type === "inbound"
                                ? Add
                                : Sub
                            }
                          />
                        </span>
                      </td>
                      {utxo.block && <td>{info.height}</td>}
                      <td className="TimeZoneFormat">
                        <span>{TimeZoneFormat(info.time)}</span>
                      </td>
                      <td>
                        <div className="amount_align">
                          <AmountBOA amount={info.amount} />
                        </div>
                      </td>
                      <td>
                        <Address
                          className="tooltip1 purpleText"
                          address={info.peer}
                          formatter={getPeerNameFromContactList}
                        />
                      </td>
                      {utxo.peer && (
                        <td>
                          <div className="tooltip1 purpleText">
                            <div className="addressFormat">
                              {getWalletNameFromHistory(info.address)}
                            </div>
                            <div className="tooltiptext1">
                              <p>{getWalletNameFromHistory(info.address)}</p>
                            </div>
                          </div>
                        </td>
                      )}
                      <td>
                        <span>
                          {isLockPeriod(info)
                            ? DateFormat(info.unlock_time)
                            : ""}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              ) : loader ? (
                <Loader />
              ) : (
                <tbody>
                  <tr className="noData">
                    <td className="inner">
                      <h3 className="text-center mb-3">{error}</h3>
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
        {/* Pending Transaction component */}
        <PendingTransaction
          showPendingTransactionDetails={showPendingTransactionOverview}
        />
      </div>

      {showPendingTransaction ? (
        <PendingTransactionOverview
          showCancellationTransactionOverview={
            showCancellationTransactionOverview
          }
          transcationRecord={{ tx_hash: txHash }}
        />
      ) : null}
    </>
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(OverView))
);
